export default "__VITE_ASSET__DDU2UHmE__"